import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import URL_UTILITY from '@/app/utility/url.utility';
import DatePicker from 'vue2-datepicker';
import updateCalibration from './updateCalibration';
import additionalInfo from './additionalInfo';
import previewDoc from '../../onlineApproval/internalWorkFlow/history/uploadDocument/previewDoc';
import weighingDashboard from'./weighingDashboard';
export default {
  name: 'weighingMachine',
  components: {
    updateCalibration,
    additionalInfo,
    DatePicker,
    previewDoc,
    weighingDashboard
  },
  watch: {
    currentPage: function () {
      this.getWeighMachineData();
    },
    perPage: function () {
      this.currentPage = 1;
      this.getWeighMachineData();
    }
  },
  data() {
    return {
      historyRowData: null,
      dunningLetterMasterId: null,
      uploadCalibrationModal: false,
      additionalModal: false,
      parent_value_set_id: null,
      showValueSetModal: false,
      payload: null,
      unsubscribe: null,
      currentPage: 1,
      totalRows: null,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      loader: false,
      vsetCode: null,
      setTimeVsetCode: null,
      machineCode: null,
      machineName: null,
      modelNo: null,
      serialNo: null,
      manufacturer: {
        text: null,
        value: null
      },
      locCostCenter: {
        text: null,
        value: null
      },
      calFreq: {
        text: null,
        value: null
      },
      status: {
        text: null,
        value: null
      },
      departUser: {
        text: null,
        value: null
      },
      capacity: null,
      accuracyReso: null,
      installDate: [],
      lastCalDate: [],
      nextCalDueDate: [],
      calCerExpiryDate: [],
      noteComments: null,
      docNo: null,
      weighMachineData: [],
      weighMachineFields: [
        {
          key: 'add',
          label: 'Add. Details',
          // variant: 'info',
          class: 'col-fix'
        },
        {
          key: 'upload_calibration',
          label: 'History',
          class: 'col-fix'
          // variant: '',
          // stickyColumn: true
        },
        {
          key: 'file_name'
        },
        {
          key: 'preview',
          class: 'text-center'
        },
        {
          key: 'serial_no',
          label: 'Serial No.'
        },
        {
          key: 'location_name',
          label: 'Location / Cost center'
        },
        {
          key: 'model_no',
          label: 'Model No.'
        },
        {
          key: 'doc_num',
          label: 'Document No.'
        },
        {
          key: 'po_number'
        },
        {
          key: 'description',
          label: 'Machine Name/Desc.',
        },
        {
          key: 'manufacturer_name',
          // label: ''
        },
        {
          key: 'book_type_code'
        },
        {
          key: 'item_code'
        },
        {
          key: 'vendor_name'
        },
        {
          key: 'hsn_sac_code',
          label: 'HSN Code'
        },
        // {
        //   key: 'status',
        //   label: 'Status'
        // },
        // {
        //   key: 'description',
        // },
      ],
      rowData: null,
      filterFlag: false,
      viewFilterVar: 'View More Filters',
      downloadDocUrl: URL_UTILITY.getOpenKmDocDeleteUrl,
      openkmAuthToken: null,
      showOpenModal: false,
      uploadedFileName: null,
      docDtlId: null,
      authToken: null,
      downloadFlag: null,
      fileExtension: null,
      dashboardModal: false
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'add') {
          // this.showHideAdditionalModal(true);
          // this.uploadRowDetail = null;
          // this.dunningLetterMasterId = null;
        }
      }
    });
  },
  methods: {
    getOpenKmAuthToken() {
      // to get auth token for open km
      const payload = {
        password: null,
        saved_password_flag: true,
        user_name: null
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmAuthenticate', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openkmAuthToken = response.data.data.token;
            // const url = this.downloadDocUrl + '/download/' + docDtlId + '?token=' + this.openkmAuthToken;
            // commonHelper.downloadFile(url, fileName);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHideOpenModal(flag, docDtlId, authToken, fileName) {
      // to open km modal
      if (flag) {
        this.fileExtension = commonHelper.getFileExtension(fileName);
      }
      if (this.fileExtension === 'xlsx') {
        alert('Not Allowed');
      } else {
        this.showOpenModal = flag;
        this.docDtlId = docDtlId;
        this.authToken = authToken;
        this.uploadedFileName = fileName;
      }
    },
    disabledDates(date) {
      return commonHelper.disabledDates(date, this.calibrationFromDate);
    },
    getWeighMachineData() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        doc_num: this.docNo,
        machine_id: this.machineCode,
        machine_des: this.machineName,
        manufacture: this.manufacturer.value,
        model_num: this.modelNo,
        serial_num: this.serialNo,
        loc_num: this.locCostCenter.value,
        install_date_from: commonHelper.formattedDate(this.installDate[0]),
        install_date_to: commonHelper.formattedDate(this.installDate[1]),
        capacity_unit: this.capacity,
        // capacity_value: this.capacity,
        accu_resolution: this.accuracyReso,
        calibration_ferq: this.calFreq.value,
        // last_calib_date: this.lastCalDate,
        next_calib_due_date_from: commonHelper.formattedDate(this.nextCalDueDate[0]),
        next_calib_due_date_to: commonHelper.formattedDate(this.nextCalDueDate[1]),
        department: this.departUser.value,
        calibration_certificate_expiry_date_from: commonHelper.formattedDate(this.calCerExpiryDate[0]),
        calibration_certificate_expiry_date_to: commonHelper.formattedDate(this.calCerExpiryDate[1]),
        // status: this.status.text
      };
      this.loader = true;
      this.$store
        .dispatch('weighMachine/getWeighMachineData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.getOpenKmAuthToken();
            this.weighMachineData = resp.data.data.page;
            this.totalRows = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.LOCATION) {
          this.locCostCenter = {
            value: item.value_set_dtl_id,
            text: item.value_code
          };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.FA_ASSET_MANUFACTURER) {
          this.manufacturer = {
            text: item.value_code,
            value: item.value_set_dtl_id
          };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.STATUS_VSET) {
          this.status = {
            text: item.value_meaning,
            value: item.value_code
          };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.FA_DEPARTMENT) {
          this.departUser = {
            text: item.value_meaning,
            value: item.value_code
          };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.CALIB_FREQUENCY) {
          this.calFreq = {
            text: item.value_meaning,
            value: item.value_code
          };
      }
      this.showValueSetModal = false;
    },
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValues(vsetCode) {
      this.vsetCode = vsetCode;
      if (this.vsetCode === appStrings.VALUESETTYPE.LOCATION) {
        this.locCostCenter = {
          value: null,
          text: null
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.FA_ASSET_MANUFACTURER) {
        this.manufacturer = {
          text: null,
          value: null
        };
      }
      else if (this.vsetCode === appStrings.VALUESETTYPE.STATUS_VSET) {
        this.status = {
          text: null,
          value: null
        };
      }
      else if (this.vsetCode === appStrings.VALUESETTYPE.FA_DEPARTMENT) {
        this.departUser = {
          text: null,
          value: null
        };
      }
      else if (this.vsetCode === appStrings.VALUESETTYPE.CALIB_FREQUENCY) {
        this.calFreq = {
          text: null,
          value: null
        };
      }
    },
    clear() {
      this.serialNo = null;
      this.machineCode = null;
      this.machineName = null;
      this.modelNo = null;
      this.docNo = null;
      this.manufacturer = {
        text: null,
        value: null
      };
      this.locCostCenter = {
        text: null,
        value: null
      };
      this.calFreq = {
        text: null,
        value: null
      };
      this.status = {
        text: null,
        value: null
      };
      this.departUser = {
        text: null,
        value: null
      };
      this.capacity = null;
      this.accuracyReso = null;
      this.installDate = [];
      this.lastCalDate = [];
      this.nextCalDueDate = [];
      this.calCerExpiryDate = [];
      this.noteComments = null;
      this.weighMachineData = [];
      this.parent_value_set_id = null;
      this.totalRows = null;
    },
    rowSelected(item) {
      this.showHideAdditionalModal(true);
      this.rowData = item;
    },
    // openLegalEntityMap(flag, item) {
    //   this.showlegalEntityMappingForm = flag;
    //   this.flexfieldRowData = item;
    // },
    showHideUploadCalibrationModal(flag, item) {
      this.uploadCalibrationModal = flag;
      this.historyRowData = item;
      if (!flag) {
        this.getWeighMachineData();
      }
    },
    showHideAdditionalModal(flag, item) {
      this.additionalModal = flag;
      this.rowData = item;
      if (!flag) {
        this.getWeighMachineData();
      }
    },
    viewMoreFilters() {
      this.filterFlag = !this.filterFlag
      if (this.filterFlag) {
        // this.showHistoryBtn=false
        this.viewFilterVar = 'View Less Filters'
      } else {
        this.viewFilterVar = 'View More Filters'
      }
    },
    openDashboardModal(flag){
      this.dashboardModal = flag
    }
  },
  beforeDestroy() {
    clearTimeout(this.setTimeVsetCode);
    this.unsubscribe();
  }
};
